import { combineReducers } from "redux";
import companysearch from "./companysearch";
import subclientsearch from "./subclientsearch";

const rootreducer = combineReducers({
  companysearch,
  subclientsearch
});

export default rootreducer;